import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShare2, FiHeart } = FiIcons;

export default function Footer({ onOpenDisclaimer }) {
  return (
    <footer className="bg-gray-50 pt-20 pb-10 border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiShare2} className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-black text-gray-900">ClipShares</span>
            </div>
            <p className="text-gray-500 font-medium max-w-sm mb-8">
              The world's fastest way to share content between devices. 
              Built for speed, security, and privacy.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400 font-bold">
              Made with <SafeIcon icon={FiHeart} className="text-red-400 w-4 h-4" /> by the ClipShares Team
            </div>
          </div>

          <div>
            <h4 className="font-black text-gray-900 uppercase tracking-widest text-xs mb-6">Product</h4>
            <ul className="space-y-4 text-sm font-bold text-gray-500">
              <li><button className="hover:text-blue-600 transition-colors">How it Works</button></li>
              <li><button className="hover:text-blue-600 transition-colors">Security</button></li>
              <li><button className="hover:text-blue-600 transition-colors">API Docs</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-black text-gray-900 uppercase tracking-widest text-xs mb-6">Legal</h4>
            <ul className="space-y-4 text-sm font-bold text-gray-500">
              <li><button onClick={onOpenDisclaimer} className="hover:text-blue-600 transition-colors">Terms of Service</button></li>
              <li><button onClick={onOpenDisclaimer} className="hover:text-blue-600 transition-colors">Privacy Policy</button></li>
              <li><button onClick={onOpenDisclaimer} className="hover:text-blue-600 transition-colors">Disclaimer</button></li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400 font-medium">
            &copy; {new Date().getFullYear()} ClipShares. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm font-bold text-gray-400">
            <span className="flex items-center gap-1.5 hover:text-gray-600 cursor-help">
              <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
              System Status: Optimal
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}